import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  logo,
  logoSmall,
  logoSmallWhite,
  search,
  // us,
  // us1,
} from "../_components/Imagepath";
 import AWS from 'aws-sdk';
 import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
const CustomerHeader = (props) => {
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };



    let user_type = localStorage.getItem("user_type");

    console.log(user_type);



  const onMenuClik = () => {
    // eslint-disable-next-line react/prop-types
    props.onMenuClick();
  };

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    };

    const maximizeBtn = document.querySelector(".win-maximize");
    maximizeBtn.addEventListener("click", handleClick);

    return () => {
      maximizeBtn.removeEventListener("click", handleClick);
    };
  }, []);
   // 🔹 Load seasons from localStorage
  let all_seasons = [];
  try {
    const seasons = JSON.parse(localStorage.getItem("all_seasons")) || [];
    all_seasons = seasons.map((s) => ({
      id: String(s.id),
      name: s.name,
      start: s.start,
      end: s.end,
      status: s.status,
    }));
  } catch (e) {
    all_seasons = [];
  }
const [selectedSeason, setSelectedSeason] = useState(
  localStorage.getItem("season_id") || ""
);

// 🔹 Sync with all_seasons ONLY if no season_id already
useEffect(() => {
  const stored = localStorage.getItem("season_id");

  if (!stored && all_seasons.length > 0) {
    const first = all_seasons[0];
    setSelectedSeason(first.id);

    localStorage.setItem("season_id", first.id);
    localStorage.setItem("season_name", first.name);
    localStorage.setItem("season_start", first.start);
    localStorage.setItem("season_end", first.end);
  }
}, [all_seasons]);

// 🔹 Whenever selectedSeason changes → update localStorage
useEffect(() => {
  if (!selectedSeason) return;

  const selected = all_seasons.find((s) => s.id === selectedSeason);
  if (selected) {
    localStorage.setItem("season_id", selected.id);
    localStorage.setItem("season_name", selected.name);
    localStorage.setItem("season_start", selected.start);
    localStorage.setItem("season_end", selected.end);
  }
}, [selectedSeason, all_seasons]);

// 🔹 Dropdown change handler
const shiftSeason = (e) => {
  const selectedId = e.target.value;
  setSelectedSeason(selectedId);

  // reload to apply globally
  window.location.reload();
};
const basePath = user_type === 'portal_user' ? "" : "/customerportal";

console.log(selectedSeason);

  const profile_image = localStorage.getItem("profile_image");
  //toast.error(response.data.data.user);
         let auth_profile_image ='';
          AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
          AWS.config.update({
          accessKeyId: AWS_ACCESS_KEY_ID,
          secretAccessKey: AWS_SECRET_ACCESS_KEY,
          region: AWS_DEFAULT_REGION,
          signatureVersion: 'v4',
          });
          const s3 = new AWS.S3();
          var params = {Bucket: AWS_BUCKET, Key: profile_image};
          auth_profile_image = s3.getSignedUrl('getObject', params);
        

  return (
    <div className="header header-one">
      <Link
        to="/profile"
        className="d-inline-flex d-sm-inline-flex align-items-center d-md-inline-flex d-lg-none align-items-center device-logo"
      >
        <img src={logo} className="img-fluid logo2 main-logo-mbile" alt="Logo" />
      </Link>
      <div className="main-logo d-inline float-start d-lg-flex align-items-center d-none d-sm-none d-md-none">
        <div className="logo-white">
          <Link to={user_type === 'portal_user' ? "/profile" : "/customerportal/profile"} >
            <img src={logo} className="img-fluid logo-blue" alt="Logo" style={{width:'60px'}}/>
          </Link>
          <Link to={user_type === 'portal_user' ? "/profile" : "/customerportal/profile"} >
            <img
              src={logoSmallWhite}
              className="img-fluid logo-small"
              alt="Logo"
            />
          </Link>
        </div>
        <div className="logo-color">
          <Link to={user_type === 'portal_user' ? "/profile" : "/customerportal/profile"} >
            <img src={logo} className="img-fluid logo-blue" alt="Logo 12"  />
          </Link>
          <Link to={user_type === 'portal_user' ? "/profile" : "/customerportal/profile"} >
            <img src={logoSmall} className="img-fluid logo-small" alt="Logo" />
          </Link>
        </div>
      </div>
      {/* Sidebar Toggle */}
      <Link to="#" id="toggle_btn" onClick={handlesidebar}>
        <span className="toggle-bars">
          <span className="bar-icons" />
          <span className="bar-icons" />
          <span className="bar-icons" />
          <span className="bar-icons" />
        </span>
      </Link>
      {/* /Sidebar Toggle */}
      {/* Search */}
      <div className="top-nav-search header-swasonshow" >
         {all_seasons.length > 0 && (
          <select
            className="form-control form-select"
            value={selectedSeason}
            onChange={shiftSeason}
          >
            {all_seasons.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
        )}
        <form style={{display:'none'}}>
          <input
            type="text"
            className="form-control"
            placeholder="Search here"
          />
          <button className="btn" type="submit">
            <img src={search} alt="img" />
          </button>
        </form>
      </div>
      <Link
        to="#"
        className="mobile_btn"
        id="mobile_btn"
        onClick={() => onMenuClik()}
      >
        <i className="fas fa-bars" />
      </Link>
 
      <ul className="nav nav-tabs user-menu">
      
        <li className="nav-item  has-arrow dropdown-heads ">
          <Link to="#" className="win-maximize">
            <i className="fe fe-maximize" />
          </Link>
        </li>
        {/* User Menu */}
        <li className="nav-item dropdown">
          <Link
            to="#"
            className="user-link  nav-link"
            data-bs-toggle="dropdown"
          >
            <span className="user-img">
              <img src={auth_profile_image} alt="img" className="profilesidebar" />
              <span className="animate-circle" />
            </span>
            <span className="user-content">
              <span className="user-name">{localStorage.getItem("fname")}</span>
              {/* <span className="user-details">{localStorage.getItem("role_type") == 1?'Administrator':'Standard'}</span> */}
            </span>
          </Link>
          <div className="dropdown-menu menu-drop-user">
            <div className="profilemenu">
             <div className="subscription-menu">
                <ul>
                  <li>
                    <Link className="dropdown-item" to={`${basePath}/profile`}>
                      Profile
                    </Link>
                  </li>
                  {user_type !== 'portal_user' && (
                    <li>
                      <Link className="dropdown-item" to={`${basePath}/change-password`}>
                        Settings
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
              <div className="subscription-logout">
                <ul>
                  <li className="pb-0">
                    <Link className="dropdown-item"  to={user_type === 'portal_user' ? "/logout" : "/customerportal/logout"}>
                      Log Out
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        {/* /User Menu */}
      </ul>
      {/* /Header Menu */}
    </div>
  );
};
export default CustomerHeader;
